import { requiredCompanyName, requiredPickupPointId } from './utils/checker';
import {
  ADD_EAN_FROM_STOCK_MANAGER,
  SET_COMMANDS,
  ADD_WARNING_REFERENCE_EXIST,
  UPDATE_COMMAND_IMPORTATION,
  DELETE_COMMAND,
  ADD_ERRORS_ITEM,
  OPEN_DIALOG_BINDING_OFFER,
  OPEN_SELECT_FORMAT_DIALOG,
  SET_UNKNOW_DELIVERY_OFFER,
  BIND_OFFER_CODE,
  RESET_IMPORT_COMMANDS,
  HANDLE_COURIER_DIALOG,
  HANDLE_LOADER,
  CREATE_BATCH_SUCCESS,
  SET_PRODUCT_IS_IN_STOCK,
  ADD_WARNINGS,
  SET_SELECTED_FORMAT
} from './actions';

const initialState = {
  commands: [],
  commandsIds: [],
  fileFormat: '',
  openDialogBindingOffer: false,
  openDialogSelectFormat: false,
  loadingImport: false,
  openCoursierDialog: false,
  productIsInStock: false,
  existingReferences: [],
  unknowDeliveryOffer: [],
  referencesWithUnknowEan: [],
  createBatchSuccess: false
};

const getDeliveryType = offerCode => {
  if (requiredPickupPointId(offerCode)) {
    return 'pickupPoint';
  }
  return requiredCompanyName(offerCode) ? 'company' : 'residential';
};

export default function ExportFormatReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_IMPORT_COMMANDS:
      return initialState;
    case HANDLE_COURIER_DIALOG:
      return {
        ...state,
        openCoursierDialog: action.data
      };
    case HANDLE_LOADER:
      return {
        ...state,
        loadingImport: action.data
      };
    case ADD_EAN_FROM_STOCK_MANAGER: {
      const referencesWithUnknowEan = [];
      return {
        ...state,
        commands: state.commands.map(command => ({
          ...command,
          items: command.items.map(item => {
            let found = null;
            let foundTwice = false;
            Object.values(action.payload).forEach(referenceWithBarcodeValue => {
              const {
                reference,
                barcodeValue,
                productId
              } = referenceWithBarcodeValue;

              if (
                item.externalReference &&
                reference &&
                item.externalReference.toString().toLowerCase() ===
                  reference.toString().toLowerCase()
              ) {
                if (found && found.productId !== productId) {
                  foundTwice = true;
                }
                found = { reference, barcodeValue, productId };
              }
            });
            if (found && !foundTwice) {
              if (!found && !!item.ean13) {
                referencesWithUnknowEan.push({
                  reference: found.reference,
                  ean13: found.barcodeValues
                });
                return item;
              }
              return {
                ...item,
                ean13:
                  item.ean13 && item.ean13.toString().length
                    ? item.ean13
                    : found.barcodeValue
              };
            }
            return item;
          })
        })),
        referencesWithUnknowEan
      };
    }
    case SET_SELECTED_FORMAT:
      return {
        ...state,
        fileFormat: action.data
      };
    case BIND_OFFER_CODE:
      return {
        ...state,
        commands: state.commands.map(command => {
          const found = action.data.unknowDeliveryOffer.find(
            offer => command.initialOfferCode === offer.name
          );
          return {
            ...command,
            offerCode: found ? found.bindingValue : command.offerCode,
            deliveryType: getDeliveryType(
              found ? found.bindingValue : command.offerCode
            )
          };
        })
      };
    case CREATE_BATCH_SUCCESS:
      return {
        ...state,
        commandsIds: action.data.commandsIds,
        createBatchSuccess: true
      };
    case ADD_WARNING_REFERENCE_EXIST:
      return {
        ...state,
        existingReferences: action.data.existingReferences,
        loadingImport: false
      };
    case ADD_ERRORS_ITEM:
      return {
        ...state,
        commands: state.commands.map((command, index) => ({
          ...command,
          errorsItem:
            index === action.data.commandIndex
              ? action.data.fullErrors
              : command.errorsItem
        }))
      };
    case ADD_WARNINGS:
      return {
        ...state,
        commands: state.commands.map((command, index) => ({
          ...command,
          warnings:
            index === action.data.commandIndex
              ? action.data.fullwarnings
              : command.warnings
        }))
      };
    case UPDATE_COMMAND_IMPORTATION:
      return {
        ...state,
        commands: state.commands.map((command, index) => ({
          ...command,
          ...command.errors,
          ...(index === action.data.commandIndex
            ? {
                ...action.data.command,
                deliveryType: getDeliveryType(action.data.command.offerCode)
              }
            : command)
        }))
      };
    case DELETE_COMMAND:
      return {
        ...state,
        commands: state.commands.filter(
          (command, index) => index !== action.data
        )
      };
    case SET_COMMANDS:
      return {
        ...state,
        commands: action.data,
        loadingImport: true
      };
    case OPEN_DIALOG_BINDING_OFFER:
      return {
        ...state,
        openDialogBindingOffer: action.data
      };
    case OPEN_SELECT_FORMAT_DIALOG:
      return {
        ...state,
        openDialogSelectFormat: action.data
      };
    case SET_UNKNOW_DELIVERY_OFFER:
      return {
        ...state,
        unknowDeliveryOffer: action.data
      };
    case SET_PRODUCT_IS_IN_STOCK:
      return {
        ...state,
        productIsInStock: action.data
      };
    default:
      return state;
  }
}
